var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('item-dialog',{ref:"dialog",on:{"refresh":function($event){return _vm.$emit('refresh', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }